module.exports = __webpack_public_path__ + "static/Velocity_Chime_EVERGREEN_FINAL_Digital-f58e1fd7ac05a6ce154d695ef2dff017.mp4";